import { services } from '@/shared/plugins/services';
import { bind } from './synchronize';

const _check = (object) => {
  const favourites = services.resolve('favourites');
  const sync = () => {
    object.favourite = !!favourites.get(object.id);
  };

  bind(favourites, sync, object);
  return sync();
};

export default function favourite(object) {
  return _check(object);
}
